import * as DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['ul', 'ol', 'li'];

export const DOMPurifyConfig: DOMPurify.Config = {
  ALLOWED_TAGS,
  ALLOWED_ATTR: [],
};
